

import { Longread, Nullable, Profile, Team, TFile } from '@brg/api';
import { ORGANIZATION_LIST } from 'shared/hooks/useGetCurrentTeam';
import {ModuleFormat} from "../../../constants/ModuleFormat";
import {executeTypograf} from "../../../utils/executeTypograf";
import { PUBLISHED_TEAM_STATUS } from 'shared/helpers/teamsStatus';
import { SUBSCRIBE_STATUS, SUBSCRIBE_VISIBILITY_STATUS } from 'shared/components/Subscribe/const';
import { ITeamButton } from 'shared/pages/teams/types';
import { ModerationType, isOuterCourseTeam } from 'shared/pages/teams/const/ModerationTypes';

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 */
export interface ComputedTeam {
    name: string;
    displayName: string;
    teamId: string;
    has: boolean;
    contentUpdate: string;
    titleImages?: TFile[];
    titleImages_en?: TFile[];
    cardId?: string;
    contexts: string[];
    ownersIDs?: string[];
    owners: Profile[];
    tabName?: any[];
    coverTitle: any;
    status: number;
    longread?: Longread;
    longreadId?: string;
    longreadId_en?: string;
    contextName?: string;
    isBilingual?: boolean;
    route?: string;
    formIds?: string[];
    tabs: any[];
    mainFilter?: any;
    hiddenHover?: boolean;
    anchorLinksLimit?: number;
    isSwitchButtonVisible?: boolean;
    isShowTeamLandingWithProjects?: boolean;
    longreadEntityLink: string;
    replaceLongreadId: string;
    longreadType?: number;
    additionalInfo: any;
    lmsCover?: number;
    lmsModuleFormat: ModuleFormat;
    moderationType?: number;
    subscribersCount?: number;
    lmsModuleStartDate: any;
    lmsModulePrice: any,
    lmsCourseTerm: any;
    lmsCourseStatus?: number;
    mainEntityType?: string;
    isLinksInsteadTitle?: boolean;
    showQu?: boolean;
    topLinks: any[];
    quCount?: number;
    isQu?: boolean;
    subscribeStatus?: SUBSCRIBE_STATUS;
    visibility?: SUBSCRIBE_VISIBILITY_STATUS;
    buttons: ITeamButton[];
    parentTeamId?: string;
    lmsModulesIds?: string[];
    isServiceTeam?: boolean;
    fieldOfActivity?: number;
    membersIDs?: string[];
    pendingMemberIds?: string[];
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 * @param team
 */
export function computeTeam(team: Nullable<Partial<Team>>): ComputedTeam {

    const routeName = Object.entries(ORGANIZATION_LIST)?.filter(([current, val]) => (val.id === team?.teamId))[0];

    const isLMS = team?.moderationType === ModerationType.LMS;
    const isOuterCourse = isOuterCourseTeam(team as Partial<ComputedTeam>);
    const baseUrl = isOuterCourse
        ? process.env.REACT_APP_URL_EDUCATION_MEDIIIA_COM
        : isLMS
            ? process.env.REACT_APP_URL_HSEDESIGN_LMS
            : process.env.REACT_APP_URL_HSEDESIGN_RU;

    return {
        name: executeTypograf(team?.name ?? 'unnamed'),
        displayName: executeTypograf(team?.displayName ?? 'unnamed'),
        teamId: team?.teamId ?? '',
        additionalInfo: team?.additionalInfo || {},
        contextName: team?.contextName || '',
        contentUpdate: team?.contentUpdate || '',
        contexts: team?.contexts || [],
        coverTitle: team?.coverTitle || [],
        has: !!team,
        titleImages: team?.titleImages ?? [],
        titleImages_en: team?.titleImages_en ?? [],
        longreadId: team?.longreadId ?? '',
        longreadId_en: team?.longreadId_en ?? '',
        longread: team?.longread ?? [],
        ownersIDs: team?.ownersIDs ?? [],
        owners: team?.owners ?? [],
        status: team?.status ?? PUBLISHED_TEAM_STATUS,
        lmsModuleStartDate: team?.lmsModuleStartDate ?? null,
        lmsModulePrice: team?.lmsModulePrice ?? 0,
        lmsModuleFormat: team?.lmsModuleFormat ?? ModuleFormat.PreRecorded,
        lmsCourseTerm: team?.lmsCourseTerm ?? null,
        lmsCourseStatus: (team as any)?.lmsCourseStatus,
        tabName: routeName,
        tabs: team?.tabs || [],
        hiddenHover: team?.hiddenHover,
        isBilingual: team?.isBilingual ?? false,
        moderationType: team?.moderationType ?? 0,
        mainEntityType: team?.mainEntityType,
        route: team?.route || (team?.contextName && `${baseUrl}/teams/${team?.contextName}${isOuterCourse ? '/brnd' : ''}`),
        mainFilter: team?.mainFilter,
        formIds: team?.formIds || [],
        isSwitchButtonVisible: team?.isSwitchButtonVisible || false,
        isLinksInsteadTitle: team?.isLinksInsteadTitle || false,
        topLinks: team?.topLinks || [],
        isShowTeamLandingWithProjects: team?.isShowTeamLandingWithProjects || false,
        showQu: (team as any)?.showQu || false,
        quCount: (team as any)?.quCount || 0,
        isQu: (team as any)?.isQu || false,
        subscribeStatus: (team as any)?.subscribeStatus,
        visibility: (team as any)?.visibility,
        longreadEntityLink: team?.longreadEntityLink || '',
        replaceLongreadId: team?.replaceLongreadId || '',
        longreadType: team?.longreadType || 0,
        lmsCover: team?.lmsCover,
        subscribersCount: team?.subscribersCount || 0,
        buttons: (team as any)?.buttons || [],
        parentTeamId: (team as any)?.parentTeamId,
        lmsModulesIds: team?.lmsModulesIds || [],
        isServiceTeam: (team as any)?.isServiceTeam,
        fieldOfActivity: (team as any)?.fieldOfActivity,
        membersIDs: team?.membersIDs,
        pendingMemberIds: (team as any)?.pendingMemberIds,
    };
}

export const computeDataWithLang = (data: any) => {
    return {
        ...data,
        currentLang: 'ru'
    }
}


import { Longread, Nullable, Profile, Team, TFile } from '@brg/api';
import { ORGANIZATION_LIST } from 'shared/hooks/useGetCurrentTeam';
import {ModuleFormat} from "../../../constants/ModuleFormat";
import {executeTypograf} from "../../../utils/executeTypograf";
import { PUBLISHED_TEAM_STATUS } from 'shared/helpers/teamsStatus';
import { SUBSCRIBE_STATUS, SUBSCRIBE_VISIBILITY_STATUS } from 'shared/components/Subscribe/const';
import { ITeamButton } from 'shared/pages/teams/types';
import { ModerationType, isOuterCourseTeam } from 'shared/pages/teams/const/ModerationTypes';

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 */
export interface ComputedTeam {
    name: string;
    displayName: string;
    teamId: string;
    has: boolean;
    contentUpdate: string;
    titleImages?: TFile[];
    titleImages_en?: TFile[];
    cardId?: string;
    contexts: string[];
    ownersIDs?: string[];
    owners: Profile[];
    tabName?: any[];
    coverTitle: any;
    status: number;
    longread?: Longread;
    longreadId?: string;
    longreadId_en?: string;
    contextName?: string;
    isBilingual?: boolean;
    route?: string;
    formIds?: string[];
    tabs: any[];
    mainFilter?: any;
    hiddenHover?: boolean;
    anchorLinksLimit?: number;
    isSwitchButtonVisible?: boolean;
    isShowTeamLandingWithProjects?: boolean;
    longreadEntityLink: string;
    replaceLongreadId: string;
    longreadType?: number;
    additionalInfo: any;
    lmsCover?: number;
    lmsModuleFormat: ModuleFormat;
    moderationType?: number;
    subscribersCount?: number;
    lmsModuleStartDate: any;
    lmsModulePrice: any,
    lmsCourseTerm: any;
    lmsCourseStatus?: number;
    mainEntityType?: string;
    isLinksInsteadTitle?: boolean;
    showQu?: boolean;
    topLinks: any[];
    quCount?: number;
    isQu?: boolean;
    subscribeStatus?: SUBSCRIBE_STATUS;
    visibility?: SUBSCRIBE_VISIBILITY_STATUS;
    buttons: ITeamButton[];
    parentTeamId?: string;
    lmsModulesIds?: string[];
    isServiceTeam?: boolean;
    fieldOfActivity?: number;
    membersIDs?: string[];
    pendingMemberIds?: string[];
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 * @param team
 */
export function computeTeam(team: Nullable<Partial<Team>>): ComputedTeam {

    const routeName = Object.entries(ORGANIZATION_LIST)?.filter(([current, val]) => (val.id === team?.teamId))[0];

    const isLMS = team?.moderationType === ModerationType.LMS;
    const isOuterCourse = isOuterCourseTeam(team as Partial<ComputedTeam>);
    const baseUrl = isOuterCourse
        ? process.env.REACT_APP_URL_EDUCATION_MEDIIIA_COM
        : isLMS
            ? process.env.REACT_APP_URL_HSEDESIGN_LMS
            : process.env.REACT_APP_URL_HSEDESIGN_RU;

    return {
        name: executeTypograf(team?.name ?? 'unnamed'),
        displayName: executeTypograf(team?.displayName ?? 'unnamed'),
        teamId: team?.teamId ?? '',
        additionalInfo: team?.additionalInfo || {},
        contextName: team?.contextName || '',
        contentUpdate: team?.contentUpdate || '',
        contexts: team?.contexts || [],
        coverTitle: team?.coverTitle || [],
        has: !!team,
        titleImages: team?.titleImages ?? [],
        titleImages_en: team?.titleImages_en ?? [],
        longreadId: team?.longreadId ?? '',
        longreadId_en: team?.longreadId_en ?? '',
        longread: team?.longread ?? [],
        ownersIDs: team?.ownersIDs ?? [],
        owners: team?.owners ?? [],
        status: team?.status ?? PUBLISHED_TEAM_STATUS,
        lmsModuleStartDate: team?.lmsModuleStartDate ?? null,
        lmsModulePrice: team?.lmsModulePrice ?? 0,
        lmsModuleFormat: team?.lmsModuleFormat ?? ModuleFormat.PreRecorded,
        lmsCourseTerm: team?.lmsCourseTerm ?? null,
        lmsCourseStatus: (team as any)?.lmsCourseStatus,
        tabName: routeName,
        tabs: team?.tabs || [],
        hiddenHover: team?.hiddenHover,
        isBilingual: team?.isBilingual ?? false,
        moderationType: team?.moderationType ?? 0,
        mainEntityType: team?.mainEntityType,
        route: team?.route || (team?.contextName && `${baseUrl}/teams/${team?.contextName}${isOuterCourse ? '/brnd' : ''}`),
        mainFilter: team?.mainFilter,
        formIds: team?.formIds || [],
        isSwitchButtonVisible: team?.isSwitchButtonVisible || false,
        isLinksInsteadTitle: team?.isLinksInsteadTitle || false,
        topLinks: team?.topLinks || [],
        isShowTeamLandingWithProjects: team?.isShowTeamLandingWithProjects || false,
        showQu: (team as any)?.showQu || false,
        quCount: (team as any)?.quCount || 0,
        isQu: (team as any)?.isQu || false,
        subscribeStatus: (team as any)?.subscribeStatus,
        visibility: (team as any)?.visibility,
        longreadEntityLink: team?.longreadEntityLink || '',
        replaceLongreadId: team?.replaceLongreadId || '',
        longreadType: team?.longreadType || 0,
        lmsCover: team?.lmsCover,
        subscribersCount: team?.subscribersCount || 0,
        buttons: (team as any)?.buttons || [],
        parentTeamId: (team as any)?.parentTeamId,
        lmsModulesIds: team?.lmsModulesIds || [],
        isServiceTeam: (team as any)?.isServiceTeam,
        fieldOfActivity: (team as any)?.fieldOfActivity,
        membersIDs: team?.membersIDs,
        pendingMemberIds: (team as any)?.pendingMemberIds,
    };
}

export const computeDataWithLang = (data: any) => {
    return {
        ...data,
        currentLang: 'ru'
    }
}
